"use client";
import { InfoAlert } from "@components/CustomAlert";
import { useRefreshToken } from "@core/hooks/endpoints/useRefreshToken";
import { useCloseSession } from "@core/hooks/useCloseSession";
import { useAuthStore } from "@core/store/storeAuth";
import { fetcherAlegriia } from "@utils/requests";
import { useEffect } from "react";
import useSWR from "swr";
import { useShallow } from "zustand/react/shallow";
import { IUser } from "../../core/types";

export function ValidateToken() {
  const { token } = useAuthStore(
    useShallow((state) => ({
      token: state.token,
    })),
  );

  const closeSession = useCloseSession();

  const { error } = useSWR<IUser>(
    token && { url: "/welcome", auth: token },
    fetcherAlegriia,
    { shouldRetryOnError: false },
  );
  //Try refresh the access token
  const { refreshToken } = useRefreshToken();
  useEffect(() => {
    refreshToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); //refreshToken create a infinite cycle

  useEffect(() => {
    if (!error) return;
    if (!token) return;

    const status = error?.response?.status;
    const errMsg = error?.response?.data?.error;

    if (errMsg === "Outdated token, please login again") {
      InfoAlert("Inicia sesión nuevamente, por favor");
      closeSession();
      return;
    }
    if (status === 401 || errMsg === "Invalid Token") {
      refreshToken?.();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error, closeSession, token]); //refreshToken create a infinite cycle

  return null;
}
